"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionController = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var AccordionController = /** @class */ (function () {
    function AccordionController(accordionBlock) {
        this.accordionBlock = accordionBlock;
        this.attachEvents();
    }
    AccordionController.collapseSection = function (element) {
        var section = element.querySelector(AccordionController.contentQuerySelector);
        section.style.height = "".concat(section.scrollHeight, "px");
        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
            section.style.height = '0';
        });
        // mark the section as "currently collapsed"
        element.classList.add(AccordionController.isCollapsedClassName);
    };
    AccordionController.expandSection = function (element) {
        var section = element.querySelector(AccordionController.contentQuerySelector);
        section.style.height = "".concat(section.scrollHeight, "px");
        // mark the section as "currently not collapsed"
        element.classList.remove(AccordionController.isCollapsedClassName);
    };
    AccordionController.prototype.attachEvents = function () {
        var _this = this;
        // single event listener for all accordion sections
        this.accordionBlock.addEventListener('click', function (event) {
            var target = event.target;
            // add interaction only if headline was clicked
            if (target.classList.contains(AccordionController.headlineClassName)) {
                // select only expanded section
                var expandedSection = _this.accordionBlock.querySelector(AccordionController.expandedSectionQuerySelector);
                // collapse section if anyone was expanded
                if (expandedSection) {
                    AccordionController.collapseSection(expandedSection);
                }
                // find parent section of click target element
                var parentAccordionSection = (0, dom_interact_1.getClosestParentElement)(target, AccordionController.sectionQuerySelector);
                // expand section if it wasn't just collapsed few lines above
                if (expandedSection !== parentAccordionSection) {
                    AccordionController.expandSection(parentAccordionSection);
                }
            }
        });
        // remove "height" from the collapsible element's inline styles after animation, so it can return to its initial value
        this.accordionBlock.addEventListener('transitionend', function () {
            var sections = _this.accordionBlock.querySelectorAll(AccordionController.contentQuerySelector);
            sections.forEach(function (section) { return (section.style.height = ''); });
        });
    };
    AccordionController.accordionQuerySelector = '.js-accordion';
    AccordionController.sectionQuerySelector = '.js-accordion-section';
    AccordionController.headlineClassName = 'js-accordion-headline';
    AccordionController.contentQuerySelector = '.js-accordion-content';
    AccordionController.isCollapsedClassName = 'is-collapsed';
    AccordionController.expandedSectionQuerySelector = "".concat(AccordionController.sectionQuerySelector, ":not(.").concat(AccordionController.isCollapsedClassName, ")");
    return AccordionController;
}());
exports.AccordionController = AccordionController;
